<template>
  <div class="daylight-view">
    <div class="show-success view" v-if="showSuccess">
      <swiper :options="swiperOption">
        <swiper-slide v-for="location in locations" :key="location.id" :class="location.theme">
          <div class="innerslide">
            <h3>{{location.city}}</h3>
            <div class="sunrise-sunset">
              <p class="sunrise icon" :class="{ 'is_past': isPast(location.sunrise) }">{{moment(location.sunrise).tz(location.timezone).format('H:mm')}}</p>
              <p class="sunset icon" :class="{ 'is_past': isPast(location.sunset) }">{{moment(location.sunset).tz(location.timezone).format('H:mm')}}</p>
              <p class="today">{{new Date().toLocaleDateString('de-DE', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}}</p>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="show_failure view" v-if="showFailure">
      <Failure></Failure>
    </div>
  </div>
</template>

<script>

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Failure from '@/views/Failure'

import axios from 'axios'
import Locations from '../locations.config.json'
import ApiConfig from '../api.config.json'

export default {
  name: 'Daylight',
  components: {
    swiper,
    swiperSlide,
    Failure
  },
  data: () => {
    return {
      now: new Date(),
      city: Locations[0].city,
      lat: Locations[0].lat,
      long: Locations[0].long,
      timezone: 'Europe/Berlin',
      locations: Locations,
      date: new Date(),
      sunrise: new Date(),
      sunset: new Date(),
      showSuccess: false,
      showFailure: false,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        }
      },
      swiperSlides: [1, 2, 3, 4, 5]
    }
  },
  methods: {
    isPast(timestamp) {
      return timestamp < this.now.getTime();
    },
    showComponent(component) {
      this.showSuccess = false;
      this.showFaile = false;
      this[`show${component}`] = true
    }
  },
  beforeCreate() {

  },
  mounted() {

    this.$nextTick(() => {
      this.locations = []
      for (const loc of Locations) {
        axios.post(`${ApiConfig[this.$ENV].API_URL}/daylight`, {
          lat: loc.lat,
          long: loc.long,
          date: new Date()
        })
        .then(response => {
          if (response.status === 200) {
            this.locations.push({
              city: loc.city,
              sunrise: new Date(Date.parse(response.data.sunrise)),
              sunset: new Date(Date.parse(response.data.sunset)),
              timezone: loc.timezone,
              orderNumber: loc.orderNumber,
              theme: loc.theme
            })
            const locationsOrderedByIndex = this.locations.slice(0);
            locationsOrderedByIndex.sort(function(a, b) {
              return a.orderNumber - b.orderNumber;
            })
            this.locations = locationsOrderedByIndex;
            this.showComponent('Success')
          } else {
            window.console.error('Failure')
            this.showComponent('Failure')
          }
        })
        .catch(e => {
          this.showComponent('Failure')
          window.console.error('Exception!')
          window.console.error(e)
        })
      }
    })
  }
}
</script>

<style lang="scss">

  .swiper-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .swiper-pagination-bullet {
    background-color: hsla(0, 0%, 100%, 0.5);
  }

  .swiper-pagination-bullet-active {
    background-color: hsla(0, 0%, 100%, 0.7);
  }

  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 15vh;
  }

  .daylight-view {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .view {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%
    }
  }

  .innerslide {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
  }

  h3 {
    font-size: 5rem;
    font-weight: 100;
    line-height: 110%;
  }

  .sunrise-sunset {
    text-align: center;
    display: flex;
    flex-direction: column;
    margin-bottom: 4rem;
  }

  p {
    position: relative;
    font-size: 5rem;
    margin: 3rem auto;
    display: inline-block;
    font-weight: 100;

    &.sunrise,
    &.sunset {
      padding-left: 3rem;

      &::before {
        content: "";
        position: absolute;
        width: 2rem;
        height: 2rem;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: cover;
      }
    }

    &.sunrise::before {
      mask: url($sunrise_icon) no-repeat 50% 50%;
    }

    &.sunset::before {
      mask: url($sunset_icon) no-repeat 50% 50%;
    }

    &.today {
      font-size: 1rem;
    }

    &.is_past {
      opacity: 0.5;
    }
  }
</style>
